var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"IconPlayBroadcast",on:{"click":_vm.onPlayPauseClick}},[_c('button',{class:['IconPlayBroadcast', _vm.getIcon, { large: _vm.large }]}),(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }